module.exports = __webpack_public_path__ + "img/H3.df13a7f3.png";